import React, { useState, useEffect } from "react";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";

import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { authKey, GET_GRN_LIST_FOR_APPROVAL, BULK_APPROVE_GRN, GET_STAKEHOLDER_CATEGORY, GET_USER_DETAILS, SEND_GRN_TO_SAP } from '../../../common/URLs';
import jwt from 'jwt-decode';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Button, Box, Card, Container, IconButton, Tooltip, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab, Tabs, CardContent } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { CheckBox } from "@mui/icons-material";
import { DialogContent, Dialog, DialogActions } from '@mui/material';
import { ConfirmPopover } from "../../../preregcamps/confirmPopover/confirmPopover";
import { ErrorPopover } from '../../../common/ErrorPopover/errorPopover';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PIT_ROLES, PROD } from "../../../common/constants";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Clear as CancelIcon, Done as ApproveIcon } from '@mui/icons-material';
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { useTranslation } from "react-i18next";
import { SendIcon, ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";

function GrnApprove() {

  const role = localStorage.getItem('role');
  const isPlantOperator = [PIT_ROLES?.PlantSCMOperator, PIT_ROLES?.PitProcessingPlant].includes(role)
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [emailId, setEmailId] = useState();
  const [accountName, setAccountName] = useState();
  //const decoded = jwt(getLocalStorageItem('id_token'));
  const [asnDetails, setAsnDetails] = useState([]);
  const [searchFilter, setSearchFilter] = useState({
    "consignmentNo": "",
    "grnDate": "",
    // "materialtype":""
  });
  const [errorMessage, setErrorMessage] = useState({
    noRecordError: '',
  });
  const decoded = jwt(getLocalStorageItem('id_token'));
  const [stakeholderDetails, setStakeholderDetails] = useState();
  const [grnListData, setGrnListData] = useState();
  const [bulkApproveGrn, setBulkApproveGrn] = useState();
  const [sendSAPGrnResponse, setSendSAPGrnResponse] = useState();

  // const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleLogModalOpen1 = () => setLogModalOpen(true);

  const [logModalOpen, setLogModalOpen] = useState(false);
  const [logModalOpen2, setLogModalOpen2] = useState(false);
  const handleLogModalOpen2 = () => setLogModalOpen2(true);
  const handleLogModalClose2 = () => { setLogModalOpen2(false); getGrnList(); }
  const [grnList, setgrnList] = useState([]);
  const [readyForSAPList, setReadyForSAPList] = useState([]);
  const [open, setOpen] = React.useState(false);
  
  const [tabValue, setTabValue] = useState(state?.tabValue ? state?.tabValue : "0");
  const [materialTabValue, setMaterialTabValue] = useState(state?.materialTabValue ?? "RawBamboo"); 

  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);

  const [confirmOpen2, setConfirmOpen2] = useState(false);
  const handleConfirmOpen2 = () => setConfirmOpen2(true);
  const handleConfirmClose2 = () => setConfirmOpen2(false);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  }

  const handleMaterialTabChange = (event, newValue) => {
    setMaterialTabValue(newValue);
  }

  useEffect(() => {
    if (getLocalStorageItem('id_token')) {
      const email = decoded.emails?.[0];
      setEmailId(email);
    }
  }, [getLocalStorageItem('id_token')]);

  useEffect(() => {
    getUserDetails();
  }, []);

  function getUserDetails() {
    apiClient
      .post(GET_USER_DETAILS,
        {
          "emailAddress": localStorage.getItem('InspectorEmail')
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setAccountName(response.data.user.firstname + " " + response.data.user.middlename + " " + response.data.user.lastname)
      })
      .catch(function (error) {
        console.log(error);
      });
  }


  useEffect(() => {
    if (decoded.extension_URN) {
      getStakeDetails();
    }
    else {
      getGrnList();
    }
  }, []);

  function getStakeDetails() {
    loaderService.showLoader()
    apiClient
      .post(GET_STAKEHOLDER_CATEGORY,
        {
          "urn": decoded.extension_URN,
          "type": ""
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setStakeholderDetails(response.data);
        // getGrnList(response.data);
        loaderService.hideLoader()
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader()
        toast.error(error.message);
      });
  }

  useEffect(() => {
    getGrnList();
  }, [tabValue, materialTabValue]); 

  function getGrnList() {
    loaderService.showLoader();
    apiClient
      .post(GET_GRN_LIST_FOR_APPROVAL,
        {
          "stakeholderUrn": decoded.extension_URN ? decoded.extension_URN : "",
          "isApproved": tabValue === "0" ? false : true ,
          "destinationStakeHolderType": isPlantOperator ? "Plant" : getLocalStorageItem('role') === PIT_ROLES?.PitProcessingLLE ? "LLE" : "",
          "destinationStakeHolderUrn": isPlantOperator ? "ABEPL" : "",
          "isSapGrnAdded": tabValue === '2' ? true : false,
          "materialType": materialTabValue 
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setGrnListData(response.data.grnApprovalList);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const handleChange = (e) => {
    if (e.target.name === "consignmentNo" || e.target.name === "grnDate") {
      setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value })
    }
  }

  const onViewDetails = (cellValues) => {
    navigate('/grnApprove/GrnFormat', {
      state: { selectedRow: cellValues.row, pageName: "grnApprove", tabValue: tabValue, materialTabValue: materialTabValue }
    });
  }


  const columns = [
    { field: 'grnNo', headerName: 'GRN No', width: 150 },
    { field: 'consignmentNo', headerName: 'Consignment No', width: 150 },
    { field: 'grnType', headerName: 'Material Type', width: 150 },
    {
      field: 'grnDate', headerName: t('reg.date'), width: 150,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
    },
    {
      field: "challanNo", headerName: t('pit.challanNo'), width: 150
    },
    { field: 'pickupTotalWeight', headerName: 'PickUp Quantity (MT)', width: 140 },
    { field: 'destinationTotalWeight', headerName: 'Unloading Quantity (MT)', width: 150 },
    { field: 'sapPoNumber', headerName: 'SAP PO Number', width: 150 },
    { field: 'approvedBy', headerName: 'Approved By', width: 200, hide: tabValue == "0" },
    {
      field: 'Action', width: 100,
      renderCell: (cellValues) => {
        return (
          <Tooltip title="View" >
            <IconButton
              color="primary"
              onClick={() => onViewDetails(cellValues)}
            >
              <ViewIcon />
            </IconButton>
          </Tooltip>
        );
      }
    },
  ];

  const columns1 = [
    { field: 'grnNo', headerName: 'GRN No', width: 150 },
    { field: 'consignmentNo', headerName: 'Consignment No', width: 150 },
    { field: 'grnType', headerName: 'Material Type', width: 150 },
    {
      field: 'grnDate', headerName: t('reg.date'), width: 150,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
    },
    { field: 'pickupTotalWeight', headerName: 'PickUp Quantity (MT)', width: 140 },
    { field: 'destinationTotalWeight', headerName: 'Unloading Quantity (MT)', width: 150 },
    { field: 'sapGrnNumber', headerName: 'SAP GRN Number', width: 150, hide: tabValue === "1" },
    { field: 'approvedBy', headerName: 'Approved By', width: 200 },
    {
      field: 'Action', width: 100,
      renderCell: (cellValues) => {
        return (
          <Tooltip title="View" >
            <IconButton
              color="primary"
              onClick={() => onViewDetails(cellValues)}
            >
              <ViewIcon />
            </IconButton>
          </Tooltip>
        );
      }
    },
  ];

  const onConfirmApprove = (e) => {
    handleConfirmClose();
    toApproveBulk(true);
  }

  const onApproveButtonClick = (e) => {
    handleConfirmOpen();
  }

  const onConfirmSendToSAP = (e) => {
    handleConfirmClose2();
    toSendToSAPBulk();
  }

  const onSendToSAPButtonClick = (e) => {
    handleConfirmOpen2();
  }

  const onApprove = (e) => {
    toApproveBulk(true);
  }

  const toApproveBulk = (e) => {
    loaderService.showLoader();
    apiClient
      .post(BULK_APPROVE_GRN,
        {
          "grnNoList": grnList,
          "approvedBy": accountName
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setBulkApproveGrn(response.data);
        getGrnList();
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  useEffect(() => {
    if (bulkApproveGrn) {
      if (bulkApproveGrn.isSuccess === true) {
        toast.success(bulkApproveGrn?.message)
        // handleLogModalOpen2();
      }
      else {
        toast.error(bulkApproveGrn?.message ? bulkApproveGrn?.message : "Error")
        // handleLogModalOpen();
      }
    }
  }, [bulkApproveGrn]);

  const toSendToSAPBulk = (e) => {
    loaderService.showLoader();
    apiClient
      .post(SEND_GRN_TO_SAP,
        {
          "grnNoList": readyForSAPList,
          "approvedBy": accountName
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setSendSAPGrnResponse(response.data);
        getGrnList();
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  useEffect(() => {
    if (sendSAPGrnResponse) {
      if (sendSAPGrnResponse.isSuccess === true) {
        toast.success(sendSAPGrnResponse?.message)
        // handleLogModalOpen2();
      }
      else {
        toast.error(sendSAPGrnResponse?.message ? sendSAPGrnResponse?.message : "Error")
        // handleLogModalOpen();
      }
    }
  }, [sendSAPGrnResponse]);


  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT44</p>}
        <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
          <Typography variant="h4" gutterBottom>
            GRN Approval
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
            <>
              <Stack direction="row" spacing={1}>
                <Button variant="contained" type="submit" hidden={tabValue !== "0"} disabled={grnList.length < 1} onClick={(e) => onApproveButtonClick(e)} startIcon={<ApproveIcon />}>Approve</Button>
                <Button variant="contained" type="submit" hidden={tabValue !== "1"} disabled={readyForSAPList.length < 1} onClick={(e) => onSendToSAPButtonClick(e)} startIcon={<SendIcon />}>Send For SAP</Button>
              </Stack>
            </>
          </Stack>
        </Stack>

        <Card>
          <TabContext value={tabValue} style={{ marginLeft: "1.5vh" }}>
            
            <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'whitesmoke' }}>
              <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                <Tab label="GRN Approval List" value="0" />
                <Tab label="Ready to Send to SAP" value="1" />
                <Tab label="Sent to SAP" value="2" />
              </TabList>
            </Box>

            <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
              <Tabs 
                value={materialTabValue} 
                onChange={handleMaterialTabChange} 
                aria-label="Material Type Tabs"
              >
                <Tab label="Raw Bamboo" value="RawBamboo" />
                <Tab label="Chip Bamboo" value="ChipBamboo" />
              </Tabs>
            </Box>

            <TabPanel value="0">
              <Box style={{ height: 445, width: '100%' }}>
                {
                  grnListData &&
                  <DataGrid rows={grnListData}
                    columns={columns}
                    pageSize={10}
                    checkboxSelection
                    components={{ Toolbar: QuickSearchToolbar }}
                    isRowSelectable={(params) => {
                      const row = params.row;

                      if (row.grnType === 'RawBamboo') {
                        return !!row.sapPoNumber;
                      }

                      if (row.grnType === 'ChipBamboo') {
                        return true; 
                      }

                      return false;
                    }}
                    onSelectionModelChange={(newSelection) => {
                      setgrnList(newSelection.map(row => {
                        let gNo = ""
                        grnListData.forEach(grn => {

                          if (row === grn.id) {
                            gNo = grn.grnNo;
                          }

                        })
                        return gNo;
                      }));
                    }}
                  />
                }
              </Box>
            </TabPanel>
            
            <TabPanel value="1">
              <Box style={{ height: 400, width: '100%' }}>
                {
                  grnListData &&
                  <DataGrid rows={grnListData}
                    columns={columns1}
                    pageSize={10}
                    components={{ Toolbar: QuickSearchToolbar }}
                    checkboxSelection
                    isRowSelectable={(params) => params.row.sapPoNumber}
                    onSelectionModelChange={(newSelection) => {
                      setReadyForSAPList(newSelection.map(row => {
                        let gNo = ""
                        grnListData.forEach(grn => {

                          if (row === grn.id) {
                            gNo = grn.grnNo;
                          }

                        })
                        return gNo;
                      }));
                    }}
                  />
                }
              </Box>
            </TabPanel>
            
            <TabPanel value="2">
              <Box style={{ height: 400, width: '100%' }}>
                {
                  grnListData &&
                  <DataGrid rows={grnListData}
                    columns={columns1}
                    pageSize={10}
                    components={{ Toolbar: QuickSearchToolbar }}                   
                  />
                }
              </Box>
            </TabPanel>
          </TabContext>

        </Card>
        <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmApprove} onClose={handleConfirmClose} action="Approve" />
        <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmSendToSAP} onClose={handleConfirmClose2} action="Send to SAP" />

      </Container>
      <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
        <DialogContent>
          <ErrorPopover title={"ERROR"} navigate={navigate} goToStakeHolderDashboard="goToStakeHolderDashboard" hideLink={true} />
        </DialogContent>

      </Dialog>
      <Dialog maxWidth='xs' fullWidth open={logModalOpen2}>
        <DialogContent>
          <ConfirmPopover title={bulkApproveGrn?.message ? bulkApproveGrn?.message : "Error"} hideLink={true} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose2}>OK</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default GrnApprove;
